import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {PostMemexFeedbackResponse} from './contracts'

export type PostMemexFeedbackBody = {
  payload: {
    rating: number
    content: string
  }
}

export async function apiPostFeedback(body: PostMemexFeedbackBody): Promise<PostMemexFeedbackResponse> {
  const apiData = getApiMetadata('memex-post-feedback-api-data')
  const {data} = await fetchJSONWith<PostMemexFeedbackResponse>(apiData.url, {method: 'POST', body})
  return data
}
